import "./App.css";
import LoginPage from "./Component/login";
import Dashboard from "./Component/dashboard";
import Contact from "./Component/contact";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const token = localStorage.getItem("token");

  fetch(`${process.env.REACT_APP_API_KEY}/authen`, {
    method: "get",
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((data) => data.json())
    .then((data) => {
      if (data.resCode === 200) {
        localStorage.setItem("user", data.data.username);
      } else {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
      }
      // console.log('Success:', token);
    });

  // Mounted once here (rather than per-page) so toast.* calls work from any
  // route, including deep inside Dashboard's nested routes — a page-local
  // <ToastContainer> only renders toasts fired while that page is mounted.
  const toastContainer = (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  );

  // console.log(token)
  if (!token) {
    return (
      <div>
        {toastContainer}
        <Routes>
          <Route path="*" element={<LoginPage />} />
          <Route path="/" element={<LoginPage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    );
  }
  return (
    <div>
      {toastContainer}
      <Routes>
        <Route path="*" element={<div>404</div>} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
        {/* <Route path='/numadd' element={<Numadd />}/>  */}
        {/* <Route path='/orderlist' element={<Orderlist />}/>  */}
      </Routes>
    </div>
  );
}

export default App;
